export default __webpack_public_path__ + "static/media/bse-payment-activated-640.df55ed47.svg";